import { createFileRoute } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import Support from "@/pages/Support";

export const Route = createFileRoute("/support")({
  head: () =>
    buildPageHead({
      title: "Support | Bigdelta",
      description: "Get help with Bigdelta. Contact our support team via chat or email.",
      path: "/support",
    }),
  component: Support,
});
